__turbopack_context__.v({
  "button": "styles-module__V6TyGa__button",
});
